export default "__VITE_ASSET__drJusEqp__"